import {Component, Inject} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {RenditionErrorsComponent} from './rendition-errors.component';

export interface RenditionDialogData {
  headline: string;
  actionName: string;
  /**
   * The rendition's own control, edited in place: its validators read the group it sits in (codec,
   * two-pass), which a detached copy could not see. The caller restores or removes it on cancel.
   */
  rendition: FormGroup;
  codecLabel: string;
  twoPass: boolean;
  crfMax: number;
  /**
   * Show the rendition's errors on opening. A blank rendition being added is invalid by
   * construction, so its errors wait until the operator has touched a field.
   */
  revealErrors: boolean;
}

/** Closes with `true` when the operator confirms, `false` (or nothing) when they cancel. */
@Component({
  selector: 'app-rendition-dialog',
  templateUrl: './rendition-dialog.component.html',
  styleUrl: './scrolling-dialog.scss',
  imports: [ReactiveFormsModule, RenditionErrorsComponent],
})
export class RenditionDialogComponent {
  constructor(public dialogRef: DialogRef<boolean>,
              @Inject(DIALOG_DATA) public data: RenditionDialogData) {
  }

  readonly bitrateHint = 'Use a whole number with an optional k or M suffix, for example 4000k.';

  get rendition(): FormGroup { return this.data.rendition; }

  get showErrors(): boolean { return this.data.revealErrors || this.rendition.dirty || this.rendition.touched; }
}
